import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

export class Exception {
    private static DEFAULT_ERROR_MESSAGE = 'Ha ocurrido un error, intente de nuevo más tarde';
    private error: ExceptionMessage;

    constructor(response: { data: ExceptionMessage } | undefined) {
        if (response) {
            this.error = response.data;
            this.error.message = this.error.message || Exception.DEFAULT_ERROR_MESSAGE;
        } else {
            this.error = {
                message: Exception.DEFAULT_ERROR_MESSAGE,
                showError: () => {},
            };
        }
    }

    get message(): string {
        return this.error.message;
    }

    showError() {
        EventBus.$emit(EventBusMessages.SHOW_ERROR, this.message);
    }
}
